<template>
  <NotLoggedInCheckoutDetails v-if="!isLoggedIn" />
  <LoggedInCheckoutDetails v-else />
</template>

<script>
import NotLoggedInCheckoutDetails from "@/esf_antarctica_lederhosenland/core/components/checkout/NotLoggedInCheckoutDetails.vue";
import LoggedInCheckoutDetails from "@/esf_antarctica_lederhosenland/core/components/checkout/LoggedInCheckoutDetails.vue";

export default {
  name: "CheckoutAddress",
  components: {
    NotLoggedInCheckoutDetails,
    LoggedInCheckoutDetails,
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters["user/getIsLoggedIn"];
    },
  },
};
</script>

<style>
</style>